module.exports = __webpack_public_path__ + "static/media/account.e4c0ac4e.svg";